import { all, takeEvery, put, call } from 'redux-saga/effects'
import axiosMethod from '../../utilities/apiCaller'

import actions from './actions'

const { txnPrivateGet, cAPrivateGet, clientConnectPrivateGet } = axiosMethod

const getAllRcCurrencies = token => {
  return txnPrivateGet('tx-service/currencies?limit=0', token).then(response => {
    return response.data.data
  })
}

export function* getRcCurrencies(values) {
  const { token } = values
  try {
    const response = yield call(getAllRcCurrencies, token)
    yield put({
      type: actions.GET_RC_CURRENCIES_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_RC_CURRENCIES_FAILURE,
      payload: err,
    })
  }
}

const getCurrenciesByAccountID = (accountID, token) => {
  return txnPrivateGet(`currency/supported-currencies/${accountID}`, token).then(response => {
    return response.data.data
  })
}

export function* getCurrenciesByAccountId(payload) {
  const { accountId, token } = payload
  try {
    const response = yield call(getCurrenciesByAccountID, accountId, token)
    yield put({
      type: actions.GET_CURRENCIES_BY_ACCOUNT_ID_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CURRENCIES_BY_ACCOUNT_ID_FAILURE,
      payload: err,
    })
  }
}

const getIntroducers = token => {
  return txnPrivateGet(`tx-service/clients?clientType=introducer&limit=0`, token).then(response => {
    return response.data.data
  })
}

export function* getAllIntroducers(values) {
  const { token } = values
  try {
    const response = yield call(getIntroducers, token)
    yield put({
      type: actions.GET_INTRODUCERS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_INTRODUCERS_FAILURE,
      payload: err,
    })
  }
}

const getMerchants = token => {
  return txnPrivateGet(`tx-service/clients?clientType=merchant&isParent=true&limit=0`, token).then(
    response => {
      return response.data.data
    },
  )
}

export function* getAllMerchants(values) {
  const { token } = values
  try {
    const response = yield call(getMerchants, token)
    yield put({
      type: actions.GET_MERCHANTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_MERCHANTS_FAILURE,
      payload: err,
    })
  }
}

const getClients = token => {
  return txnPrivateGet(`tx-service/clients?limit=0`, token).then(response => {
    return response.data.data
  })
}

export function* getAllClients(values) {
  const { token } = values
  try {
    const response = yield call(getClients, token)
    yield put({
      type: actions.GET_CLIENTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CLIENTS_FAILURE,
      payload: err,
    })
  }
}

const getIntroducerClients = (clientId, token) => {
  return clientConnectPrivateGet(`entities/clients/parent/${clientId}`, token).then(response => {
    const introducerClients = response.data.data.entities.filter(
      item => !!item.genericInformation.registeredCompanyName,
    )
    return introducerClients
  })
}

export function* getSelectedIntroducerClients(values) {
  try {
    const response = yield call(getIntroducerClients, values.value, values.token)
    yield put({
      type: actions.GET_INTRODUCERS_CLIENTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_INTRODUCERS_CLIENTS_FAILURE,
      value: err,
    })
  }
}

const getMerchantClients = (clientId, token) => {
  return clientConnectPrivateGet(`entities/clients/parent/${clientId}`, token).then(response => {
    const merchantClients = response.data.data.entities.filter(
      item => !!item.genericInformation.registeredCompanyName,
    )
    return merchantClients
  })
}

export function* getSelectedMerchantClients(values) {
  try {
    const response = yield call(getMerchantClients, values.value, values.token)
    yield put({
      type: actions.GET_MERCHANTS_CLIENTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_MERCHANTS_CLIENTS_FAILURE,
      value: err,
    })
  }
}

const getClientById = (clientId, token) => {
  return txnPrivateGet(`tx-service/clients/${clientId}`, token).then(response => {
    return response.data.data
  })
}

export function* getClient(values) {
  const { value } = values

  const { clientId, token } = value
  try {
    const response = yield call(getClientById, clientId, token)
    yield put({
      type: actions.GET_CLIENT_BY_ID_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CLIENT_BY_ID_FAILURE,
      payload: err,
    })
  }
}

const getCustomer = payload => {
  const { entityId, token } = payload
  return clientConnectPrivateGet(`entities/clients/${entityId}`, token).then(response => {
    response.data.data.tradingName = response.data.data.genericInformation.tradingName
    response.data.data.registeredCompanyName =
      response.data.data.genericInformation.registeredCompanyName
    response.data.data.parentId = response.data.data.genericInformation.parentId
    return response.data.data
  })
}

export function* handleCustomer(payload) {
  try {
    const response = yield call(getCustomer, payload.value)

    yield put({
      type: actions.GET_CLIENT_BY_ID_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CLIENT_BY_ID_FAILURE,
      payload: err,
    })
  }
}

const getClientPartnersByParentId = (parentId, token) => {
  return clientConnectPrivateGet(`entities/clients/parent/${parentId}`, token).then(response => {
    const clientPartners = response.data.data.entities.filter(
      item => !!item.genericInformation.registeredCompanyName,
    )
    return clientPartners
  })
}

export function* getClientPartners(values) {
  const { payload } = values

  const { parentId, token } = payload
  try {
    const response = yield call(getClientPartnersByParentId, parentId, token)
    yield put({
      type: actions.GET_CLIENT_PARTNER_BY_PARENT_ID_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CLIENT_PARTNER_BY_PARENT_ID_FAILURE,
      payload: err,
    })
  }
}

// const getChangeStreamingChannels = token => {
//   return txnPrivateGet(`tx-service/stream-channels`, token).then(response => {
//     return response.data.data
//   })
// }

// export function* getStreamingChannels(values) {
//   const { token } = values

//   try {
//     const response = yield call(getChangeStreamingChannels, token)

//     yield put({
//       type: actions.GET_STREAMING_CHANNELES_SUCCESS,
//       value: response,
//     })
//   } catch (err) {
//     yield put({
//       type: actions.GET_STREAMING_CHANNELES_FAILURE,
//       payload: err,
//     })
//   }
// }

// CA implementation

const getCurrencies = token => {
  return cAPrivateGet('currencies?limit=0', token).then(response => {
    return response.data.data.currency
  })
}

export function* getAllCurrencies(values) {
  const { token } = values
  try {
    const response = yield call(getCurrencies, token)
    yield put({
      type: actions.GET_CURRENCIES_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CURRENCIES_FAILURE,
      payload: err,
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_CLIENT_BY_ID_DEPRECATED, getClient),
    takeEvery(actions.GET_CLIENT_BY_ID, handleCustomer),
    takeEvery(actions.GET_RC_CURRENCIES, getRcCurrencies),
    takeEvery(actions.GET_CURRENCIES, getAllCurrencies),
    takeEvery(actions.GET_INTRODUCERS, getAllIntroducers),
    takeEvery(actions.GET_MERCHANTS, getAllMerchants),
    takeEvery(actions.GET_CLIENTS, getAllClients),
    takeEvery(actions.GET_CURRENCIES_BY_ACCOUNT_ID, getCurrenciesByAccountId),
    takeEvery(actions.GET_INTRODUCERS_CLIENTS, getSelectedIntroducerClients),
    takeEvery(actions.GET_MERCHANTS_CLIENTS, getSelectedMerchantClients),
    takeEvery(actions.GET_CLIENT_PARTNER_BY_PARENT_ID, getClientPartners),
    // takeEvery(actions.GET_STREAMING_CHANNELES, getStreamingChannels),
  ])
}
